module.exports = __webpack_public_path__ + "static/media/-_overtime .3e836cce.png";